import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  reportData: null,
};

const reportSlice = createSlice({
  name: "companyProjectReport",
  initialState,
  reducers: {
    getReportStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getReportSuccess: (state, action) => {
      state.loading = false;
      state.reportData = action.payload;
      state.error = null;
    },
    getReportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearReportData: (state) => {
      state.reportData = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getReportStart,
  getReportSuccess,
  getReportFailure,
  clearReportData,
  clearError,
} = reportSlice.actions;

export default reportSlice.reducer;
